import { Transition } from "@headlessui/react";
import React from "react";
import { Space, Table, Tag } from "antd";
import { getStyleStatus } from "components/Leasing/utils/leasing.u";
import { format } from "date-fns";

const columns = [
  {
    title: "History Id",
    dataIndex: "history_id",
    key: "history_id",
    render: (text) => <a>{text}</a>,
  },
  {
    title: "แอดมิน",
    dataIndex: "adminNameLatest",
    key: "adminNameLatest",
  },
  {
    title: "สถานะ",
    dataIndex: "loan_status",
    key: "loan_status",
    render: (_, { loan_status }) => (
      <div className={getStyleStatus(loan_status)}>{loan_status}</div>
    ),
  },
  {
    title: "การบันทึกข้อมูล",
    dataIndex: "action",
    key: "action",
    render: (_, { action }) => (
      <div className="w-30">{action}</div>
    ),
  },
  {
    title: "วันที่สร้าง",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (_, { createdAt }) => (
      <div>{format(new Date(createdAt), "dd-MM-yyyy HH:mm")}</div>
    ),
  },
];

function HistoriesModalTable({
  histories,
  openModalHistories,
  setOpenModalHistories,
}) {
  return (
    <Transition
      show={openModalHistories}
      enter="transition-opacity duration-75"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-150"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div
        style={{ zIndex: 98 }}
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
      ></div>

      <div style={{ zIndex: 99 }} class="fixed inset-0 z-10 overflow-y-auto mb-60">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl">
            <div class="bg-white">
              <Table
                pagination={{ pageSize: 10 }}
                dataSource={histories}
                columns={columns}
              />
              <div className="flex items-center justify-end pb-2 px-4">
                <button className="px-2 py-1 bg-red-500 text-white rounded cursor-pointer" onClick={() => setOpenModalHistories(false)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  );
}

export default HistoriesModalTable;
